import React from "react";

const PandingApproval = ({style = {}, size = "36", className = "", fill = "#4E525F", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M25.473 15.683a7.389 7.389 0 0 1 4.628-2.574 5.597 5.597 0 0 0 2.574-1.738 5.742 5.742 0 0 0-.694-8.04 5.677 5.677 0 0 0-9.305 3.822 7.32 7.32 0 0 1-4.863 6.934l6.06 5.094c.205-1.29.758-2.5 1.6-3.498ZM2 31.333h24.753V34H2v-2.667Zm22.664-2.573L8.082 14.83l2.751-3.077 16.583 13.935-2.752 3.072Z"
        />
    </svg>
);

export default PandingApproval;
